import { render, staticRenderFns } from "./toc.vue?vue&type=template&id=fed4bb96&"
import script from "./toc.vue?vue&type=script&lang=js&"
export * from "./toc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports